class Hive {
  vm = {};

  options = {
    os: this.getOS(),
    countrycode: navigator.language,
    position: this.getLinkParam('p'),
    channel: this.getLinkParam('c'),
    bigo_id: this.getBigoId(),
    type: this.getLinkParam('t'),
    web_type: this.getWebType(),
    owner_sid: this.getOwnerSid()
  };

  initHive(vm) {
    this.vm = vm;
    this.options = {
      os: this.getOS(),
      countrycode: navigator.language,
      position: this.getLinkParam('p'),
      channel: this.getLinkParam('c'),
      bigo_id: this.getBigoId(),
      type: this.getLinkParam('t'),
      web_type: this.getWebType(),
      owner_sid: this.getOwnerSid()
    };
  }

  mergeData(e, gData) {
    const obj = {};
    Object.keys(e).forEach((i) => {
      obj[i] = e[i];
    });
    Object.keys(gData).forEach((i) => {
      obj[i] = gData[i];
    });
    return obj;
  }

  encodeFormDataToUrlSearch(data) {
    const arr = [];
    Object.keys(data).forEach((i) => {
      arr.push(i + '=' + encodeURIComponent(data[i]));
    });

    return arr.join('&');
  }

  getLinkParam(param) {
    let paramArr = [''];
    if (window && window.location) {
      paramArr = window.location.search.substring(1).split('&');
    }

    const paramObj = {};
    for (let i = 0; i < paramArr.length; i += 1) {
      const arr = paramArr[i].split('=');
      // eslint-disable-next-line
      paramObj[arr[0]] = arr[1];
    }
    return paramObj[param] || '';
  }

  getOS() {
    let ua = '';
    if (window && window.navigator) {
      ua = window.navigator.userAgent;
    }

    const isAndroid = /android/i.test(ua);
    const isIos = /iphone|ipad|ipod/i.test(ua);
    return isAndroid ? 'android' : isIos ? 'ios' : 'other';
  }

  // 页面类型：1. 分享页 2. 从官网打开
  getWebType() {
    // url的pathname中有sid说明为分享页
    const isSharePage = this.getLinkParam('b');
    return isSharePage ? 1 : 2;
  }

  // 分享链接上sid/A_B_C上的A字段
  getOwnerSid() {
    const urlPath = location.pathname;
    const sid = this.getLinkParam('sid');
    if (urlPath.includes('sid')) {
      return urlPath.match(/.*sid\/(.*)/) && urlPath.match(/.*sid\/(.*)/)[1];
    } else if (sid) {
      return sid;
    }
    return '';
  }

  // 1：开播中 2：主播结束页面
  getResult() {
    if (this.vm?.liveInfo?.alive === 1 || this.vm?.liveStatus === 'live_play') {
      return 1;
    }
    return 2;
  }

  // 埋点上报的时刻，房间的类型，有可能房间类型跟 type 是不一样的
  getLiveType() {
    if (this.vm?.videoInfo) {
      return this.vm?.videoInfo?.roomStatus;
    }
    return this.vm?.config?.roomStatus;
  }

  getBigoId() {
    // 如果链接上存在b字段，则上报链接上的b的值
    const id = this.getLinkParam('b') || this.getLinkParam('room');
    if (id) return id;
    // 不存在则链接为从官网打开的链接或官网首页
    const numReg = /\d+/g;
    const pathname = location.pathname;
    const regRes = pathname.match(numReg);
    return regRes ? regRes[0] : '';
  }

  send(eventId, eventData = {}) {
    const img = new Image();
    eventData.event_id = eventId;
    // result: 直播状态，需动态获取
    this.options.result = this.getResult();
    // live_type:
    this.options.live_type = this.getLiveType();
    img.src =
      'https://dotting.cube.tv/live/statistics/report?' +
      this.encodeFormDataToUrlSearch(this.mergeData(this.options, eventData));
    return img.src;
  }
}

export default process.client ? new Hive() : {};
